import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaShieldAlt, FaRocket, FaHandHoldingUsd } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function AuftragInfoCards() {
  const { t } = useTranslation();

  const steps = t("AuftragInfoCards.steps", { returnObjects: true });
  const advantages = t("AuftragInfoCards.advantages", { returnObjects: true });
  const icons = [
    <FaShieldAlt key={"FaShieldAlt"} size={40} className="text-orange mb-3" />,
    <FaRocket key={"FaRocket"} size={40} className="text-orange mb-3" />,
    <FaHandHoldingUsd key={"FaHandHoldingUsd"} size={40} className="text-orange mb-3" />
  ];

  return (
    <section className="py-5">
      <Container>
        <h4 className="text-center text-orange mb-4">
          {t("AuftragInfoCards.main_title")}
        </h4>
        <p className="text-center text-muted mb-5">
          {t("AuftragInfoCards.main_description")}
        </p>
        <Row className="mb-5">
          {Array.isArray(steps) &&
            steps.map((step, index) => (
              <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <Card className="h-100 border-0 shadow-sm p-3 text-center">
                  <Card.Title className="text-orange">{step.title}</Card.Title>
                  <Card.Text>{step.text}</Card.Text>
                </Card>
              </Col>
            ))}
        </Row>
        <h4 className="text-center text-orange mb-4">
          {t("AuftragInfoCards.advantages_title")}
        </h4>
        <p className="text-center text-muted mb-5">
          {t("AuftragInfoCards.advantages_description")}
        </p>
        <Row>
          {Array.isArray(advantages) &&
            advantages.map((advantage, index) => (
              <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <Card className="h-100 border-0 shadow-sm p-3 text-center d-flex align-items-center">
                  {icons[index]}
                  <Card.Title className="text-orange">{advantage.title}</Card.Title>
                  <Card.Text>{advantage.text}</Card.Text>
                </Card>
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
}